import BaseService from '@root/core/class/BaseService';

class buskService extends BaseService {
  public getForwardingDetail = (id: string) => {
    return this.get(`/forwardings/detail/${id}`);
  };

  public getPostList = (page: number, id: string) => {
    return this.get(
      `/forwardings/posts?searchBy=forwarding.id&page=${page}&limit=10&search=${id}`
    );
  };

  public getDetail = (id: number) => {
    return this.get(`/forwardings/posts/${id}`);
  };

  public updateForwardingDetail = (id: number, data: any) => {
    return this.put(`/forwardings/${id}`, data);
  };

  public createForwarding = (data: any) => {
    return this.post('/forwardings', data);
  };

  public createDialog = (data: {
    postId: number;
    content: string;
    attachment: string[];
  }) => {
    return this.post('/forwardings/posts/dialogs', data);
  };

  public getDialogList = (id: number) => {
    return this.get(`/dialogs/${id}`);
  };

  public uploadFile = (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('attachments', file);
      console.log('Appending file:', file.name);
    });

    return this.post('/forwardings/upload-file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).catch((error) => {
      if (error.response?.status === 413) {
        alert('용량이 너무 큽니다');
      }
      throw error;
    });
  };
  public updateDialog = (
    id: number,
    attachment?: string[],
    content?: string
  ) => {
    return this.put(`/forwardings/posts/dialogs/${id}`, {
      content,
      attachment
    });
  };

  public forceCancel = (id: number) => {
    return this.put(`/forwardings/posts/force_end/${id}`);
  };
}

export default new buskService('/api/v1/admin', true);
